/* eslint-disable */
export default {
  _dimboregular: 'dimboregular',
  _cloudy_with_a_chance_of_lovRg: 'cloudy_with_a_chance_of_lovRg',
}